// global
import global from "../../assets/traslations/es/global.json";

// auth
import forgot_pass from "../../assets/traslations/es/auth/forgot_pass.json";
import login from "../../assets/traslations/es/auth/login.json";
import profile from "../../assets/traslations/es/auth/profile.json";
import register from "../../assets/traslations/es/auth/register.json";
import reset_pass from "../../assets/traslations/es/auth/reset_pass.json";
import validate_email from "../../assets/traslations/es/auth/validate_email.json";

// master
import contact from "../../assets/traslations/es/master/contact.json";
import client from "../../assets/traslations/es/master/client.json";
import delivery from "../../assets/traslations/es/master/delivery.json";
import driver from "../../assets/traslations/es/master/driver.json";
import transport from "../../assets/traslations/es/master/transport.json";
import operators from "../../assets/traslations/es/master/operators.json";
import zone from "../../assets/traslations/es/master/zone.json";
import invoiceRoute from "../../assets/traslations/es/master/invoiceRoute.json";
import supplierMaster from "../../assets/traslations/es/master/supplier/supplierMaster.json";
import binnacleOC from "../../assets/traslations/es/master/supplier/binnacleOC.json";
import tarrif from "../../assets/traslations/es/master/tarrif.json";
import fuel from "../../assets/traslations/es/master/fuel.json";

// reports
import invoices from "../../assets/traslations/es/reports/invoices.json";
import orders from "../../assets/traslations/es/reports/orders.json";
import routeCost from "../../assets/traslations/es/reports/routeCost.json";
import routes from "../../assets/traslations/es/reports/routes.json";

// transactions
import order from "../../assets/traslations/es/transactions/order.json";
import quote from "../../assets/traslations/es/transactions/quote.json";
import route from "../../assets/traslations/es/transactions/route.json";
import invoice from "../../assets/traslations/es/transactions/invoice.json";
import invoiceProvider from "../../assets/traslations/es/transactions/invoiceProvider.json";
import invoiceClient from "../../assets/traslations/es/transactions/invoiceClient.json";
import supplierCost from "../../assets/traslations/es/master/supplier/supplierCost.json";
import supplierDrivers from "../../assets/traslations/es/master/supplier/supplierDrivers.json";
import supplierTransport from "../../assets/traslations/es/master/supplier/supplierTransport.json";

// config
import cost from "../../assets/traslations/es/config/cost.json";
import transportBrand from "../../assets/traslations/es/config/transportBrand.json";
import transportSupplier from "../../assets/traslations/es/config/transportSupplier.json";
import usersProfiles from "../../assets/traslations/es/config/usersProfiles.json";
import log from "../../assets/traslations/es/config/log.json";
import billingCode from "../../assets/traslations/es/config/billingCode.json";

//others
import notifications from "../../assets/traslations/es/others/notification.json";


const es = {
    // global
    global,

    // auth
    forgot_pass,
    login,
    profile,
    register,
    reset_pass,
    validate_email,

    // master
    tarrif,
    contact,
    client,
    delivery,
    driver,
    transport,
    operators,
    zone,
    invoiceRoute,
    supplierMaster,
    supplierCost,
    supplierDrivers,
    supplierTransport,
    binnacleOC,
    fuel,

    // reports
    invoices,
    orders,
    routeCost,
    routes,

    // transactions
    order,
    quote,
    route,
    invoice,
    invoiceProvider,
    invoiceClient,

    // config
    cost,
    transportBrand,
    transportSupplier,
    usersProfiles,
    log,
    billingCode,

    //others
    notifications,
}

export default es;
